import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button as MuiButton, } from '@mui/material';
import { forwardRef } from 'react';
import { styled } from '../../utils';
import { CircularProgress } from '../Progress';
export const Button = forwardRef(function Button(props, ref) {
    const { loading, children, disabled, dataName, ...otherProps } = props;
    return (_jsxs(ButtonStyled, { "data-name": dataName, disableElevation: true, disabled: disabled || loading, ref: ref, ...otherProps, children: [loading && (_jsx(LoadingStyled, { children: _jsx(CircularProgress, { size: 16, color: "inherit" }) })), children] }));
});
export const ButtonStyled = styled(MuiButton)(({ theme }) => ({
    '&:hover': {
        textDecoration: 'none',
    },
    borderRadius: '100px',
    padding: theme.spacing(1, 2),
    transition: 'width .15s ease-in-out',
    minWidth: theme.spacing(6),
    [theme.breakpoints.up('lg')]: {
        padding: theme.spacing(1.5, 3),
    },
    '&.MuiButton-contained': {
        '&.Mui-disabled': {
            backgroundColor: theme.palette.secondary.contrastText,
            color: theme.palette.white.dark,
        },
    },
    '&.MuiButton-outlined': {
        '&.Mui-disabled': {
            backgroundColor: theme.palette.white.main,
            borderColor: theme.palette.white.dark,
            color: theme.palette.white.dark,
        },
    },
    '&.MuiButton-containedPrimary': {
        backgroundColor: theme.palette.primary.dark,
        '&:hover': {
            backgroundColor: theme.palette.primary.main,
        },
    },
    '&.MuiButton-sizeLarge': {
        padding: theme.spacing(1, 3),
        fontSize: '1.125rem',
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(1, 2),
            fontSize: '1rem',
        },
    },
    '&.MuiButton-sizeMedium': {
        padding: theme.spacing(1, 2),
        [theme.breakpoints.down('sm')]: {
            fontSize: '0.875rem',
        },
    },
    '&.MuiButton-sizeSmall': {
        padding: theme.spacing(1, 2),
        minWidth: theme.spacing(5),
        fontSize: '0.875rem',
        [theme.breakpoints.down('sm')]: {
            fontSize: '0.8125rem',
        },
    },
    '& .MuiTouchRipple-rott > * ': {
        backgroundColor: theme.palette.primary.lighter,
    },
}));
export const LoadingStyled = styled('span')(({ theme }) => ({
    marginRight: theme.spacing(1.5),
    display: 'inherit',
    alignItems: 'inherit',
    justifyContent: 'inherit',
}));
